<template>
    <div>
        <div v-if="selectedName" class="mb-5">
            Kiválasztva: {{ selectedName }}
        </div>

        <div id="postapontvalasztoapi"></div>

        <t-modal
            v-model="openModal"
            class="flex items-center justify-center z-2000"
            close="flex items-center justify-center bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50"
        >
            <div
                class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100"
            >
                <svg
                    class="h-6 w-6 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
            <h3 class="text-center text-lg leading-6 font-medium text-gray-900">
                {{ __('A kiválasztott pont ebben a kategóriában nem elérhető. Kérlek válaszd az alábbi opciót: ') }} <strong>{{ selectedGroupLabel }}</strong>
            </h3>
        </t-modal>
    </div>
</template>

<script>
export default {
    name: 'MplParcelLocker',

    props: {
        pickupPoint: {
            default: null
        },

        skipGroups: {
            type: Object,
            required: false,
            default() {
                return {
                    "80_trendmaker": true,
                    "70_mediamarkt": true,
                    "60_egyenipartnerek": true,
                    "50_coop": true,
                    "30_csomagautomata":false,
                    "20_molkut": true,
                    "10_posta": true
                }
            }
        },
    },

    data() {
        return {
            openModal: false,
            selectedName: null,
            selectedGroupLabel: null,
            groupsLabel: {
                "80_trendmaker": "MPL PostaPontok",
                "70_mediamarkt": "MPL PostaPontok",
                "60_egyenipartnerek": "MPL PostaPontok",
                "50_coop": "MPL PostaPontok",
                "30_csomagautomata": "MPL Csomagautomata",
                "20_molkut": "MPL PostaPontok",
                "10_posta": "MPL Postán maradó csomag"
            },
        }
    },

    created() {
        ppapi.insertMap('postapontvalasztoapi');

        ppapi.showAllFilters = false;
        ppapi.hideMyLocationBtn = true;

        ppapi.skipgroups = this.skipGroups;

        ppapi.onSelect = (data) => {
            this.selectedGroupLabel = null

            if (this.skipGroups[data.group]) {
                this.selectedGroupLabel = this.groupsLabel[data.group]
                this.openModal = true

                return
            }

            this.selectedName = data.name
            this.$emit('input', data)
        }
    },
}
</script>
